/**
 * External dependencies
 */
import { useMemo } from 'react';
import { SxProps } from '@mui/system';
import { Theme } from '@mui/material/styles/createTheme';

/**
 * Internal dependencies
 */
import * as GeneralSx from './general';
import * as PrintSx from './print';

export interface useLayout {
  general: typeof GeneralSx;
  print: typeof PrintSx;
  mergedSx: (...sx: Array<ICombineMuiSx | SxProps<Theme>>) => SxProps<Theme>;
}
export interface ICombineMuiSx {
  condition: boolean;
  sx: SxProps<Theme>;
}

/**
 * 描述 : 取得 sxLayout 的 hook
 * 備註 : You cannot spread `sx` directly because `SxProps` (typeof sx) can be an array.
 */
export default function useLayout(): useLayout {
  /* Global & Local State */
  const mergedSx = (...sx: Array<ICombineMuiSx | SxProps<Theme>>): SxProps<Theme> =>
    sx.reduce((acc: SxProps<Theme>, curr: ICombineMuiSx | SxProps<Theme>) => {
      if ((curr as ICombineMuiSx).condition) {
        return { ...acc, ...(curr as ICombineMuiSx).sx } as SxProps<Theme>;
      }
      return { ...acc, ...(curr as SxProps<Theme>) } as SxProps<Theme>;
    }, {} as SxProps<Theme>);
  /* Main */
  return useMemo(
    () => ({
      general: GeneralSx,
      print: PrintSx,
      mergedSx
    }),
    []
  );
}
